import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { BreadcrumbTrail } from 'common/breadcrumb-trail';
import { AppContext } from 'context';
import { appPageBreadcrumb, getLastVaultId } from 'helpers/vault-breadcrumbs';

interface AppBreadcrumbProps {
  className?: string;
}

// Trail for the account-level screens (Collaborators, Store, Account, …),
// rooted at "Dashboard" — the vault currently open in the app context, else
// the last one visited. Renders nothing on screens it doesn't know, and for
// logged-out visitors.
export const AppBreadcrumb = ({ className }: AppBreadcrumbProps) => {
  const { state } = useContext(AppContext);
  const { pathname } = useLocation();
  if (!state.logged) return null;
  const vaultId =
    (state.currentVault?.id ?? 0) > 0
      ? state.currentVault!.id
      : getLastVaultId();
  const crumbs = appPageBreadcrumb(pathname, vaultId);
  if (!crumbs) return null;
  return <BreadcrumbTrail crumbs={crumbs} className={className} />;
};
